import { paths } from '@/routes/helpers/paths';
import { LogoContainer, LogoIcon, LogoTextIcon } from './navbar.styles';
import { filterCssPropertiesFromMetadata } from '@/helpers/filter-css-properties-from-metadata';
import { useCurrentAccountData } from '@/hooks/use-current-account-data';

export function Logo() {
  const { data, isLoading } = useCurrentAccountData();

  return (
    <LogoContainer to={paths.home()}>
      {data && !isLoading ? (
        <>
          <LogoTextIcon
            src={data.logo.url}
            alt={data.name}
            styleOverride={filterCssPropertiesFromMetadata(data.logo.metadata)}
          />

          <LogoIcon
            src={data.icon.url}
            alt={data.name}
            styleOverride={filterCssPropertiesFromMetadata(data.icon.metadata)}
          />
        </>
      ) : null}
    </LogoContainer>
  );
}
